// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeStoryBaseEditTemplate_heading__yCTRp","buttonLink":"LandscapeStoryBaseEditTemplate_buttonLink__Wvkjb"};